import SettingHeader from '../../../components/settings/SettingHeader'

import NotificationSettings from './_components/NotificationSettings';
const Page = () => {
    return (
        <div>
            <SettingHeader heading="Text"  />
            <NotificationSettings />
        </div>
    )
}

export default Page